import { BaseService } from './base-service';

class FeishuService extends BaseService {
  /**
   *  获取授权信息
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof FeishuService
   */
  getFeishuAuth(params) {
    return this.request({
      method: 'get',
      url: `/feishu/external/signature`,
      params
    });
  }
  /**
   *  根据userId 获取openId
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof FeishuService
   */
  getUserOpenId(params) {
    return this.request({
      method: 'get',
      url: `/user/feishu/get`,
      params
    });
  }
}

export const feishuService = new FeishuService();
